import VersionModal from "./VersionModal";

export default VersionModal;